<template>
  <div>
    <div style="padding: 10px; min-height: 100px">
      <x-table
        listApi="biz.customer.vet.doctor.list"
        paginationLayout="total, sizes, prev, next, jumper"
        actionFixed="right"
        emptyLabel="暂无执业兽医信息"
        :btnList="btnList"
        :defaultParams="defaultParams"
        :fieldList="fieldList"
        :actionList="actionList"
        :paramList="paramList"
        :actionWidth="160"
      >
        <template slot="row-info" slot-scope="scope">
          <div>
            {{ scope.row.vetName || "-" }}
          </div>
          <div style="color: #919191">
            {{ scope.row.vetCertificateId || "未完善执业证书信息" }}
          </div>
          <div style="color: #919191">
            {{ scope.row.vetCompany || "未完善执业单位信息" }}
          </div>
        </template>
      </x-table>
    </div>
  </div>
</template>

<script>
import formPage from "./__vet_doctor_form.vue";

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        storeGuid: this.pageParams.storeGuid
      };
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      paramList: [
      ],
      fieldList: [
        {
          label: "医师信息",
          minWidth: "250",
          slot: 'info',
        },
        {
          label: '状态',
          type: 'tag',
          width: '100',
          size: 'mini',
          render: row => (row.optStatus == 1 ? '正常' : '禁用'),
          tagType: row => (row.optStatus == 1 ? 'success' : 'danger'),
        },
      ],
      actionList: [
        {
          label: '编辑',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.vet.doctor.update"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '编辑执业兽医信息',
              refresh,
              component: formPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: row => (row.optStatus == 1 ? '禁用' : '启用'),
          click: (row, tag, refresh) => {
            const label = row.optStatus == 1 ? '禁用' : '启用';
            this.$confirm(`确定${label}?`, '提示', {
              type: 'warning',
            }).then(() => {
              this.requestApi('biz.customer.vet.doctor.update', {
                guid: row.guid,
                optStatus: row.optStatus == 1 ? 0 : 1,
              }, {
                showError: true
              }).then(() => {
                this.success('保存成功');
                refresh && refresh();
              });
            });
          },
        },
        {
          label: '删除',
          linkType: 'danger',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.vet.doctor.delete"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$confirm('确定删除?', '提示', {
              type: 'warning',
            }).then(() => {
              this.requestApi('biz.customer.vet.doctor.delete', {
                guid: row.guid,
                storeGuid: row.storeGuid,
              }, {
                showError: true
              }).then(() => {
                this.success('删除成功');
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: '新增兽医',
          type: 'primary',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.vet.doctor.create"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '新增兽医',
              refresh,
              component: formPage,
              params: this.defaultParams,
            });
          },
        }
      ],
    };
  },
};
</script>